import { Link } from 'react-router-dom';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export type TileTint = 'green' | 'orange' | 'blue' | 'purple' | 'pink' | 'teal';

const TINT_BG: Record<TileTint, string> = {
  green: 'bg-tile-green',
  orange: 'bg-tile-orange',
  blue: 'bg-tile-blue',
  purple: 'bg-tile-purple',
  pink: 'bg-tile-pink',
  teal: 'bg-tile-teal',
};

const TINT_ICON: Record<TileTint, string> = {
  green: 'text-emerald-600',
  orange: 'text-orange-500',
  blue: 'text-blue-600',
  purple: 'text-violet-600',
  pink: 'text-pink-600',
  teal: 'text-teal-600',
};

interface ServiceTileProps {
  to: string;
  icon: LucideIcon;
  title: string;
  subtitle: string;
  tint: TileTint;
}

/** One pastel card on the home grid: icon, name, one-line hint. */
export function ServiceTile({ to, icon: Icon, title, subtitle, tint }: ServiceTileProps) {
  return (
    <Link
      to={to}
      className={cn(
        'flex flex-col items-center gap-2 rounded-2xl px-2 py-4 text-center transition-transform active:scale-[0.97] focus-visible:ring-ring/50 focus-visible:ring-[3px] outline-none',
        TINT_BG[tint],
      )}
    >
      <span className={cn('bg-card flex size-12 items-center justify-center rounded-2xl shadow-xs', TINT_ICON[tint])}>
        <Icon className="size-6" aria-hidden="true" />
      </span>
      <span className="text-sm font-semibold leading-tight">{title}</span>
      <span className="text-muted-foreground text-[11px] leading-tight">{subtitle}</span>
    </Link>
  );
}
